export const LOADING = "LOADING"
export const LOADED = "LOADED"
export const REDIRECT = "REDIRECT"
export const LOGIN = "LOGIN"
export const REGISTER = "REGISTER"
export const FORGOTPASSWORD = "FORGOTPASSWORD"
export const LOGOUT = "LOGOUT"
export const ENUMS = "ENUMS"
